<ng-container *ngFor="let contentSection of contentSections; let i = index">
	<ng-container *ngIf="adminMode || evaluateConditions(contentSection.visibilityConditions)">
		<div *ngIf="adminMode" class="add-container">
			<button
				mat-stroked-button
				color="secondary"
				class="icon-only add-container-button"
				(click)="openDialog.emit({ contentSection: undefined, order: contentSection.order - 1 })"
			>
				<mat-icon>add</mat-icon>
			</button>
		</div>

		<div>
			<button
				*ngIf="enableNewCreativePackageRequests && contentSection.title"
				mat-button
				matTooltip="Submit a request for new template, or enhancement for existing template."
				i18n-matTooltip="Request new Ad Button Tooltip@@requestNewAdButtonTooltip"
				color="primary"
				class="md-4 request-new-ad-button pull-right"
				i18n="Request new Ad Button@@requestNewAdButtonCta"
				(click)="customEvent.emit({ name: 'requestNewCreativePackage', args: [] })"
			>
				<mat-icon>info</mat-icon>
				Request New Ad
			</button>
		</div>

		<app-content-section
			class="mb-8"
			[contentSection]="contentSection"
			[adminMode]="adminMode"
			(openDialog)="openDialog.emit($event)"
			(delete)="delete.emit($event)"
			(customEvent)="customEvent.emit($event)"
			(moveUp)="moveContentSection(contentSection, 'up')"
			(moveDown)="moveContentSection(contentSection, 'down')"
			(selectedListing)="selectedListing.emit($event)"
			(selectedPartialListing)="selectedPartialListing.emit($event)"
		></app-content-section>
	</ng-container>
</ng-container>

<div *ngIf="adminMode" class="add-container">
	<button mat-stroked-button class="icon-only add-container-button" color="medium" (click)="openDialog.emit({ contentSection: undefined, order: contentSections[contentSections?.length - 1]?.order + 10 })">
		<mat-icon>add</mat-icon>
	</button>
</div>
